import React from 'react';
import { useIntl } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import Heading from '@/components/switchback/Heading/Heading';
import Link from '@/components/switchback/Link/Link';

import css from './PopularPostsList.module.css';

const PopularPostsList = ({ topPosts }) => {
  const intl = useIntl();

  return (
    <MaxWidth className="py-12 m-auto">
      <Heading className="mb-4 highlight autoType800" level={2}>
        {intl.formatMessage({ defaultMessage: 'Our top articles', id: 'wCkb12' })}
      </Heading>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-x-4 gap-y-2 lg:gap-y-4">
        {topPosts.posts.map(post => {
          return (
            <Link className={css.link} key={post.id} href={`/blog/${post.slug}`}>
              <Heading
                className="highlight autoType500 leading-6"
                level={3}
                dangerouslySetInnerHTML={{ __html: post.title }}
              />
            </Link>
          );
        })}
      </div>
    </MaxWidth>
  );
};

export default PopularPostsList;
